import { useEffect } from 'react';
import { AxiosError } from 'axios';
import { IError } from '@heidi-pay/heidi-common-fe/types';
import { useMutation } from '@tanstack/react-query';
import { usePortalError } from '@hooks/usePortalError';
import { IMerchantPortalApplicationsExtraData } from '@schemas/merchantPortal/types/applicationsExtraData';
import { Endpoints } from '@utils/enums';
import { postDataToEndpoint } from '@utils/postDataToEndpoint';

interface IGetApplicationsExtraDataRequest {
  external_contract_uuid: string[];
}

interface IUseGetApplicationsExtraData {
  externalContractUuids: string[] | undefined;
  hasExtraDataColumns: boolean;
}

export const useGetApplicationsExtraData = ({
  externalContractUuids,
  hasExtraDataColumns,
}: IUseGetApplicationsExtraData) => {
  const { handleAxiosError } = usePortalError();
  const externalContractUuidsStr = externalContractUuids?.join(',');

  const { data: applicationsExtraData, mutate: getApplicationsExtraData } =
    useMutation<
      IMerchantPortalApplicationsExtraData,
      AxiosError<IError>,
      IGetApplicationsExtraDataRequest
    >(
      requestData =>
        postDataToEndpoint({
          endpoint: Endpoints.GetApplicationsExtraData,
          requestData,
        }),
      {
        onError: error => handleAxiosError(error, 'FAILED'),
      },
    );

  useEffect(
    () => {
      if (
        hasExtraDataColumns &&
        externalContractUuids &&
        externalContractUuids.length > 0
      ) {
        getApplicationsExtraData({
          external_contract_uuid: externalContractUuids,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasExtraDataColumns, externalContractUuidsStr, getApplicationsExtraData],
  );

  return applicationsExtraData;
};
